import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { fetchOrder } from "../lib/api";
import { formatAUDexact } from "../data/signsPricing";
import { CheckCircle2 } from "lucide-react";

export default function OrderConfirmation() {
  const { orderNumber } = useParams();
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    fetchOrder(orderNumber).then(setOrder).catch(() => setErr(true));
  }, [orderNumber]);

  if (err) return <div className="App"><Header /><div className="p-14 text-center">Order not found</div><Footer/></div>;
  if (!order) return <div className="App"><Header /><div className="p-14 text-center text-slate-500">Loading…</div><Footer/></div>;

  return (
    <div className="App">
      <Header />
      <section className="max-w-3xl mx-auto px-5 lg:px-8 pt-12 pb-20">
        <div className="sf-card p-10 text-center">
          <CheckCircle2 size={44} className="mx-auto text-[#10B981]"/>
          <div className="eyebrow mt-4">Order confirmed</div>
          <h1 className="font-display text-4xl font-black mt-2">Thanks, {order.first_name}!</h1>
          <p className="text-slate-600 mt-3">We've received your order. We'll be in touch shortly to confirm payment and schedule production.</p>
          <div className="mt-6 inline-flex items-center gap-2 bg-[#F3EFEA] rounded-xl px-5 py-3 font-mono-brand text-sm font-bold" data-testid="order-number">
            Order {order.order_number}
          </div>
        </div>

        <div className="sf-card p-6 mt-6">
          <div className="eyebrow mb-3">Items</div>
          <div className="space-y-3">
            {order.items.map((i, idx) => (
              <div key={idx} className="flex justify-between text-sm" data-testid={`order-item-${idx}`}>
                <div>
                  <div className="font-semibold">{i.product_name}</div>
                  <div className="text-slate-500 text-xs">
                    {i.shape ? `${i.shape} · ` : ""}{i.size} · {i.quantity.toLocaleString()}{i.kinds > 1 ? ` (${i.qty_per_design.toLocaleString()} × ${i.kinds} designs)` : ""}
                    {i.print_sides && <> · {i.print_sides === "double" ? "Double-sided" : "Single-sided"}</>}
                  </div>
                </div>
                <div className="price-tick font-semibold">{i.needs_quote ? <span className="text-[#003DA5] text-sm font-bold tracking-wide uppercase">Quote</span> : formatAUDexact(i.line_total)}</div>
              </div>
            ))}
          </div>
          <div className="h-px bg-[#E2DDD5] my-4"/>
          <div className="space-y-1 text-sm">
            <div className="flex justify-between"><span className="text-slate-500">Subtotal</span><span className="price-tick font-semibold">{formatAUDexact(order.subtotal)}</span></div>
            <div className="flex justify-between"><span className="text-slate-500">GST (10%)</span><span className="price-tick font-semibold">{formatAUDexact(order.gst)}</span></div>
            <div className="flex justify-between" data-testid="order-delivery"><span className="text-slate-500">Delivery</span><span className="font-semibold">{order.local_pickup ? "Pickup" : "To be confirmed"}</span></div>
            <div className="flex justify-between font-display font-black text-xl mt-2"><span>Total</span><span className="price-tick">{formatAUDexact(order.total)}</span></div>
          </div>
        </div>
        <div className="text-center mt-8">
          <Link to="/" className="btn-outline">Back to home</Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
